import { useEffect, useState } from "react";
import { FaLock } from "react-icons/fa";
import { EnvBadge } from "../EnvBadge/EnvBadge";
import { qrDataUrlFromOtpauth } from "../../../utils/totpQr";
import "./TotpChallengeForm.css";

/**
 * Desafio TOTP (verify / enroll) — mesmo padrão visual do login Kapital Map.
 * Usado em Login e no modal «Trocar de Usuário».
 */
export function TotpChallengeForm({
  mode = "verify",
  secret = "",
  qrDataUrl: qrDataUrlProp = "",
  otpauthUri = "",
  alias = "",
  info = "",
  error = "",
  code = "",
  onCodeChange,
  onSubmit,
  onCancel,
  loading = false,
  showEnvBadge = false,
  autoFocus = true,
  idPrefix = "totp",
}) {
  const [qrLocal, setQrLocal] = useState("");
  const qrSrc = qrDataUrlProp || qrLocal;
  const enroll = mode === "enroll";

  useEffect(() => {
    if (!enroll || !otpauthUri || qrDataUrlProp) {
      setQrLocal("");
      return undefined;
    }
    let cancelled = false;
    void qrDataUrlFromOtpauth(otpauthUri)
      .then((url) => {
        if (!cancelled && url) setQrLocal(url);
      })
      .catch(() => {
        /* chave manual */
      });
    return () => {
      cancelled = true;
    };
  }, [enroll, otpauthUri, qrDataUrlProp]);

  const digits = String(code || "").replace(/\D/g, "");

  return (
    <form
      className="totp-challenge"
      onSubmit={onSubmit}
      noValidate
      aria-labelledby={`${idPrefix}-title`}
    >
      <h1 id={`${idPrefix}-title`} className="totp-challenge__brand">
        Kapital Map
      </h1>
      <p className="totp-challenge__subtitle">
        Verificação em dois passos (TOTP)
      </p>
      {showEnvBadge ? (
        <div className="totp-challenge__env">
          <EnvBadge />
        </div>
      ) : null}
      {alias ? (
        <p className="totp-challenge__contract" role="status">
          Contrato: <strong>{alias}</strong>
        </p>
      ) : null}
      {info ? (
        <p className="totp-challenge__feedback totp-challenge__feedback--ok" role="status">
          {info}
        </p>
      ) : null}
      {error ? (
        <p
          className="totp-challenge__feedback totp-challenge__feedback--error"
          role="alert"
        >
          {error}
        </p>
      ) : null}
      {enroll ? (
        <div className="totp-challenge__enroll">
          {qrSrc ? (
            <img
              className="totp-challenge__qr"
              src={qrSrc}
              alt="QR code TOTP"
              width={200}
              height={200}
            />
          ) : (
            <p className="totp-challenge__feedback" role="status">
              A preparar o QR… Se não aparecer, use a chave manual abaixo.
            </p>
          )}
          {secret ? (
            <p className="totp-challenge__feedback" role="note">
              Chave manual: <strong>{secret}</strong>
            </p>
          ) : null}
        </div>
      ) : null}
      <div className="totp-challenge__input-group">
        <input
          type="text"
          name="totp_code"
          inputMode="numeric"
          autoComplete="one-time-code"
          pattern="\d{6}"
          maxLength={6}
          placeholder="Código de 6 dígitos"
          value={code}
          onChange={(e) =>
            onCodeChange(e.target.value.replace(/\D/g, "").slice(0, 6))
          }
          autoFocus={autoFocus}
          required
          disabled={loading}
        />
        <FaLock className="totp-challenge__icon" aria-hidden />
      </div>
      <div className="totp-challenge__actions">
        <button
          type="button"
          className="totp-challenge__btn totp-challenge__btn--secondary"
          disabled={loading}
          onClick={onCancel}
        >
          Cancelar
        </button>
        <button
          type="submit"
          className="totp-challenge__btn"
          disabled={loading || digits.length !== 6}
        >
          {loading ? "A verificar…" : "Confirmar"}
        </button>
      </div>
    </form>
  );
}
